// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ErrorSimple, Loader } from '@scts-ui/component-library';
import '../app/app.scss';
import { useConfigLoader } from '@scts/utilities';
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import HomeComponent from './features/home/home-component';
import { RecoilRoot } from 'recoil';
import LoginComponent from './components/login/login';
import { AuthProvider } from './contexts/auth/auth-provider';

export const App = () => {
  const { isLoading, isIdle, isError, error, data } = useConfigLoader();

  return (
    <>
      {(isLoading || isIdle) && (
        <div>
          <Loader loadingText={'loading app'} padding={'15% 30%'} />
        </div>
      )}

      {isError && (
        <ErrorSimple
          icon="bi-exclamation-square-fill"
          margin="15% 30%"
          message={
            'There has been an error contacting the server. Please contact support. ' +
            error.message
          }
          padding="0.75rem"
          iconFontSize={'2.9rem'}
          textFontSize={'1rem'}
        />
      )}

      {data && (
        <MsalProvider
          instance={new PublicClientApplication(data.configuration)}
        >
          <RecoilRoot>
            <UnauthenticatedTemplate>
              <LoginComponent />
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
              <AuthProvider>
                <HomeComponent />
              </AuthProvider>
            </AuthenticatedTemplate>
          </RecoilRoot>
        </MsalProvider>
      )}
    </>
  );
};

export default App;
